var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-scroll-wrapper",style:(_vm.customStyle)},[_c('ul',{staticClass:"row-scroll-items-nav"},[_vm._t("default"),_c('li',{staticClass:"padding-right-li"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }